module.exports = __webpack_public_path__ + "static/media/pizza1.0c7253eb.png";